// Angular imports
import { Component, OnInit } from '@angular/core';

// Service imports
import { ScreenService } from '../../_services/shared-services/screen.service';

// Model imports
import { CreateUserParameterDto } from '../../_models/create-user-parameter-dto';
import { RegistrationEditorResultDto } from '../../_models/registration/registration-editor-result-dto';
import { RegistrationParameterDto } from '../../_models/registration/registration-parameter-dto';

// Constants imports
import { RegistrationConstants } from '../../_constants/registration-constants';

// CC-Common imports
import { RxjsUtils } from '@therealmanage/ciranet-ui-common';

@Component({
  selector: 'app-user-registration',
  templateUrl: './user-registration.component.html',
  styleUrls: ['./user-registration.component.scss'],
  standalone: false
})
export class UserRegistrationComponent implements OnInit {
  isSmallScreen = false;

  showSignup = true;
  showAccountPortal = false;
  showEmailCommunication = false;
  showTextCommunication = false;

  screens: Array<string> = [];

  userInfo: CreateUserParameterDto;
  registrationEditor: RegistrationEditorResultDto;

  constructor(private screenService: ScreenService) {}

  ngOnInit() {
    this.userInfo = new CreateUserParameterDto();
    this.addScreen(RegistrationConstants.SIGNUP);

    this.updateScreenSize();
    RxjsUtils.safeSubscribe(this.screenService.changed, () =>
      this.updateScreenSize()
    );
  }

  onRegistrationUpdate(event): void {
    this.userInfo = event.userInfo;
    this.registrationEditor = event.registrationEditor;

    this.showSignup = false;

    if (!!this.registrationEditor.registrationEmailContact.contactDetailId) {
      this.userInfo.contactInfo = new RegistrationParameterDto();
      this.userInfo.contactInfo.emailData =
        this.registrationEditor.registrationEmailContact;
      //assign phone data for the same contact of the email to populate in the text-options step
      if (
        !!this.registrationEditor.phoneData &&
        this.registrationEditor.phoneData.length > 0
      ) {
        const phoneData = this.registrationEditor.phoneData.find(
          (d) =>
            d.subTypeId ===
              this.registrationEditor.defaultPhoneSubTypeId.toString() &&
            d.contactId === this.userInfo.contactInfo.emailData.contactId
        );
        if (!!phoneData) {
          this.userInfo.contactInfo.phoneData = phoneData;
        }
      }

      this.addScreen(RegistrationConstants.SIGNUP_EMAIL);
      this.showEmailCommunication = true;
    } else {
      this.addScreen(RegistrationConstants.SIGNUP_ACCOUNT);
      this.showAccountPortal = true;
    }
  }

  onPortalAccountUpdate(event): void {
    this.userInfo = event;
    this.showAccountPortal = false;

    this.addScreen(RegistrationConstants.SIGNUP_EMAIL);
    this.showEmailCommunication = true;
  }

  onPortalAccountPreviousClick(): void {
    this.showAccountPortal = false;
    this.showPreviousScreen();
  }

  onEmailCommunicationUpdate(event): void {
    this.userInfo = event;

    this.showEmailCommunication = false;

    this.addScreen(RegistrationConstants.SIGNUP_TEXT);
    this.showTextCommunication = true;
  }

  onEmailCommunicationPreviousClick(): void {
    this.showEmailCommunication = false;
    this.showPreviousScreen();
  }

  onTextCommunicationPreviousClick(): void {
    this.showTextCommunication = false;
    this.showPreviousScreen();
  }

  private showPreviousScreen(): void {
    this.removeScreen();
    const prevScreen = this.screens[this.screens.length - 1];

    if (prevScreen === RegistrationConstants.SIGNUP_ACCOUNT) {
      this.showAccountPortal = true;
    } else if (prevScreen === RegistrationConstants.SIGNUP_EMAIL) {
      this.showEmailCommunication = true;
    } else if (prevScreen === RegistrationConstants.SIGNUP_TEXT) {
      this.showTextCommunication = true;
    } else if (prevScreen === RegistrationConstants.SIGNUP) {
      this.showSignup = true;
    }
  }

  private addScreen(screen: string): void {
    this.screens.push(screen);
  }

  private removeScreen(): void {
    this.screens.pop();
  }

  private updateScreenSize(): void {
    this.isSmallScreen = this.screenService.isSmallScreen();
  }
}
